export default {
  props: {
    id: Number,
    title: String,
    weight: Number,
    volume: Number,
    composition: String,
    price: Number,
    imgUrl: String,
    isHit: Boolean,
    isNew: Boolean,
    filter_1: Boolean,
    filter_2: Boolean,
    filter_3: Boolean,
    category: String,
    isFavorite: Boolean,
    isAdded: Boolean,
    onClickFavorite: Function,
    onClickAdd: Function
  }
};